import { AlertTriangle, Inbox } from 'lucide-react';
import { BrandSpinner, Button, Surface } from '@agenda-facil/ui';

export function PageLoader({ label = 'Carregando…' }: { label?: string }) {
  return (
    <div className="grid min-h-64 place-items-center p-8">
      <BrandSpinner size="lg" label={label} />
    </div>
  );
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <Surface className="grid justify-items-center gap-4 p-8 text-center">
      <span className="grid size-12 place-items-center rounded-full bg-[var(--danger-soft)] text-[var(--danger)]">
        <AlertTriangle size={22} />
      </span>
      <div><h3 className="font-extrabold">Algo não saiu como esperado</h3><p className="mt-1 text-sm text-[var(--muted-foreground)]">{message}</p></div>
      {retry && <Button variant="secondary" onClick={retry}>Tentar novamente</Button>}
    </Surface>
  );
}

export function EmptyState({ title, message }: { title: string; message: string }) {
  return (
    <Surface className="grid justify-items-center gap-3 border-dashed p-8 text-center">
      <Inbox className="text-[var(--muted-foreground)]" size={28} />
      <div><h3 className="font-extrabold">{title}</h3><p className="mt-1 text-sm text-[var(--muted-foreground)]">{message}</p></div>
    </Surface>
  );
}
